import $ from 'jquery';
import JSZip from 'jszip';
import moment from 'moment';

// @ts-ignore
window.$ = $;
// @ts-ignore
window.jQuery = $;
// @ts-ignore
window.moment = moment;
// @ts-ignore
window.JSZip = JSZip;
